export const env = {
  VITE_API_BASEURL: import.meta.env.VITE_API_BASEURL,
  VITE_FAVICON: import.meta.env.VITE_FAVICON,
  VITE_SEGMENT_ANALYTICS: import.meta.env.VITE_SEGMENT_ANALYTICS,
  VITE_USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
  VITE_AUTH_DOMAIN: import.meta.env.VITE_AUTH_DOMAIN,
  VITE_MODE: import.meta.env.VITE_MODE,
  NODE_ENV: import.meta.env.NODE_ENV,
  VITE_LINKED_IN_DISABLED: import.meta.env.VITE_LINKED_IN_DISABLED,
  VITE_VITALLY_TOKEN: import.meta.env.VITE_VITALLY_TOKEN,
  VITE_CAN_USE_REFRESH_TOKENS: import.meta.env.VITE_CAN_USE_REFRESH_TOKENS,
  VITE_USERBACK_TOKEN: import.meta.env.VITE_USERBACK_TOKEN,
  VITE_APP_VERSION: import.meta.env.VITE_APP_VERSION,
};
